/* eslint-disable jsdoc/require-returns */
/* eslint-disable valid-jsdoc */
import { Point } from '../primitives/point';
import { Rect } from '../primitives/rect';
import { intersect2 } from '../utility/diagram-util';
import { canBridge } from '../utility/constraints-util';
/**
 * ConnectorBridging defines the bridging behavior
 */
/** @private */
export class ConnectorBridging {
    /**
     * @param {Connector}conn - provide the target  value.
     * @param {Diagram}diagram - provide the target  value.
     * @private
     */
    updateBridging(conn, diagram) {
        const lastBridge = [];
        let bounds;
        conn.bridges = [];
        if (canBridge(conn, diagram)) {
            // if (this.canBridge(conn, diagram)) {
            const points1 = this.getPoints(conn);
            bounds = Rect.toBounds(points1);
            const bridgeSpacing = conn.bridgeSpace;
            const bgedir = diagram.bridgeDirection || 'Top';
            let count = -1;
            const quads = diagram.connectors;
            for (let q = 0; q < quads.length; q++) {
                const connector1 = quads[parseInt(q.toString(), 10)];
                //EJ2-868564- Bridging is enabled when connector visibility is set to False
                if (conn && connector1 && conn.id !== connector1.id && connector1.visible) {
                    const points2 = this.getPoints(connector1);
                    const bounds1 = Rect.toBounds(points2);
                    if (this.intersectsRect(bounds, bounds1)) {
                        const intersectPts = this.intersect(points1, points2, false, bgedir, true);
                        if (intersectPts.length > 0) {
                            for (let i = 0; i < intersectPts.length; i++) {
                                let fullLength = 0;
                                let length = 0;
                                let segmentIndex = 0;
                                let pointIndex = 0;
                                const obj = this.getLengthAtFractionPoint(conn, intersectPts[parseInt(i.toString(), 10)]);
                                if (obj.pointIndex !== -1) {
                                    length = obj.lengthFractionIndex;
                                    fullLength = obj.fullLength;
                                    segmentIndex = obj.segmentIndex;
                                    pointIndex = obj.pointIndex;
                                    const stBridge = this.getPointAtLength((length - (bridgeSpacing / 2)), points1);
                                    let enBridge = this.getPointAtLength((length + (bridgeSpacing / 2)), points1);
                                    let fractLength = (length - (bridgeSpacing / 2)) / fullLength;
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    fractLength = (length + (bridgeSpacing / 2)) / fullLength;
                                    if (this.isEmptyPoint(enBridge)) {
                                        enBridge = stBridge;
                                    }
                                    let end;
                                    const start = conn.sourcePoint;
                                    if (conn.type === 'Straight') {
                                        end = conn.targetPoint;
                                    }
                                    else {
                                        end = conn.intermediatePoints[parseInt(pointIndex.toString(), 10)];
                                    }
                                    const angle = this.angleCalculation(start, end);
                                    if (lastBridge.length) {
                                        const fixedPoint = conn.sourcePoint;
                                        const fix = Math.abs(this.lengthCalculation(fixedPoint, enBridge));
                                        let var1 = 0;
                                        let insertAt = -1;
                                        count = -1;
                                        for (let k = 0; k < lastBridge[parseInt(segmentIndex.toString(), 10)].bridges.length; k++) {
                                            count++;
                                            const arcSeg = lastBridge[parseInt(segmentIndex.toString(), 10)].bridges[parseInt(k.toString(), 10)];
                                            var1 = Math.abs(this.lengthCalculation(fixedPoint, arcSeg.endPoint));
                                            if (fix < var1) {
                                                insertAt = count;
                                                break;
                                            }
                                        }
                                        if (insertAt >= 0) {
                                            //let paths: ArcSegment;
                                            // eslint-disable-next-line max-len
                                            const paths = this.createSegment(stBridge, enBridge, angle, bgedir, pointIndex, conn, diagram);
                                            paths.target = connector1.id;
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridges.splice(insertAt, 0, paths);
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridges.join();
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridgeStartPoint.splice(insertAt, 0, stBridge);
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridgeStartPoint.join();
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].segmentIndex = segmentIndex;
                                        }
                                        else {
                                            //let paths: ArcSegment;
                                            // eslint-disable-next-line max-len
                                            const paths = this.createSegment(stBridge, enBridge, angle, bgedir, pointIndex, conn, diagram);
                                            paths.target = connector1.id;
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridges.push(paths);
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridgeStartPoint.push(stBridge);
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].segmentIndex = segmentIndex;
                                        }
                                    }
                                    else {
                                        if (!isNaN(stBridge.x) && !isNaN(stBridge.y) && !this.isEmptyPoint(enBridge)) {
                                            //let arcs: ArcSegment;
                                            const bges = [];
                                            const bgept = [];
                                            // eslint-disable-next-line max-len
                                            const arcs = this.createSegment(stBridge, enBridge, angle, bgedir, pointIndex, conn, diagram);
                                            const bgseg = {
                                                bridges: bges, bridgeStartPoint: bgept, segmentIndex: segmentIndex
                                            };
                                            arcs.target = connector1.id;
                                            const stPoints = [];
                                            const edPoints = [];
                                            stPoints.push(stBridge);
                                            edPoints.push(enBridge);
                                            lastBridge[parseInt(segmentIndex.toString(), 10)] = bgseg;
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridges.push(arcs);
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].bridgeStartPoint = stPoints;
                                            lastBridge[parseInt(segmentIndex.toString(), 10)].segmentIndex = segmentIndex;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (lastBridge.length !== 0) {
                this.firstBridge(lastBridge, conn, bridgeSpacing);
            }
        }
    }
    /**
     * @param {BridgeSegment[]}bridgeList - provide the bridgeList  value.
     * @param {Connector}connector - provide the connector  value.
     * @param {number}bridgeSpacing - provide the bridgeSpacing  value.
     * @private
     */
    firstBridge(bridgeList, connector, bridgeSpacing) {
        for (let i = 0; i < bridgeList.length; i++) {
            const bridge = bridgeList[parseInt(i.toString(), 10)];
            for (let k = 1; k < bridge.bridges.length; k++) {
                if (Point.findLength(bridge.bridges[parseInt(k.toString(), 10)].endPoint, bridge.bridges[k - 1].endPoint) < bridgeSpacing) {
                    bridge.bridges[k - 1].endPoint = bridge.bridges[parseInt(k.toString(), 10)].endPoint;
                    const subBridge = bridge.bridges[k - 1];
                    const arc = this.createBridgeSegment(subBridge.startPoint, subBridge.endPoint, subBridge.angle, bridgeSpacing, subBridge.sweep);
                    bridge.bridges[k - 1].path = arc;
                    bridge.bridges.splice(k, 1);
                    bridge.bridgeStartPoint.splice(k, 1);
                    k--;
                }
            }
            let pre = connector.sourcePoint;
            for (let j = 0; j < bridge.bridges.length; j++) {
                const subBridge = bridge.bridges[parseInt(j.toString(), 10)]; //const preventChecking: boolean = true;
                pre = subBridge.endPoint;
                connector.bridges.push(subBridge);
            }
        }
    }
    /**
     * @returns { ArcSegment } checkSourcePointInTarget method .\
     * @param {PointModel}st- provide the st  value.
     * @param {PointModel}end- provide the end  value.
     * @param {number}angle- provide the angle  value.
     * @param {BridgeDirection}direction- provide the direction  value.
     * @param {number}index- provide the index  value.
     * @param {Connector}conn- provide the conn  value.
     * @param {Diagram} diagram- provide the diagram  value.
     * @private
     */
    createSegment(st, end, angle, direction, index, conn, diagram) {
        //let arc: string;
        //let sweep: number;
        const path = {
            angle: 0, endPoint: { x: 0, y: 0 }, target: '', path: '',
            segmentPointIndex: -1, startPoint: { x: 0, y: 0 }, sweep: 1, rendered: false
        };
        const sweep = this.sweepDirection(angle, direction, conn, diagram);
        const arc = this.createBridgeSegment(st, end, angle, conn.bridgeSpace, sweep);
        path.path = arc;
        path.startPoint = st;
        path.endPoint = end;
        path.angle = angle;
        path.segmentPointIndex = index;
        path.sweep = sweep;
        return path;
    }
    /**
     * @param {PointModel}startPt- provide the startPt  value.
     * @param {PointModel}endPt- provide the endPt  value.
     * @param {number}angle- provide the angle  value.
     * @param {number}bridgeSpace- provide the bridgeSpace  value.
     * @param {number}sweep- provide the sweep  value.
     * @private
     */
    createBridgeSegment(startPt, endPt, angle, bridgeSpace, sweep) {
        const path = 'A ' + bridgeSpace / 2 + ' ' + bridgeSpace / 2 + ' ' + angle + ' , 1 ' + sweep + ' ' + endPt.x + ',' + endPt.y;
        return path;
    }
    /**
     * @param {number}angle- provide the source value.
     * @param {BridgeDirection}bridgeDirection- provide the source value.
     * @param {Connector}connector- provide the source value.
     * @param {Diagram}diagram- provide the source value.
     * @private
     */
    sweepDirection(angle, bridgeDirection, connector, diagram) {
        const angle1 = Math.abs(angle);
        let sweep;
        switch (bridgeDirection) {
            case 'Top':
            case 'Bottom':
                sweep = 1;
                if (angle1 >= 0 && angle1 <= 90) {
                    sweep = 0;
                }
                break;
            case 'Left':
            case 'Right':
                sweep = 1;
                if (angle < 0 && angle >= -180) {
                    sweep = 0;
                }
                break;
        }
        if (bridgeDirection === 'Right' || bridgeDirection === 'Bottom') {
            if (sweep === 0) {
                sweep = 1;
            }
            else {
                sweep = 0;
            }
        }
        return sweep;
    }
    /** @private */
    getPointAtLength(length, pts) {
        let run = 0;
        let pre;
        let found = { x: 0, y: 0 };
        for (let i = 0; i < pts.length; i++) {
            const pt = pts[parseInt(i.toString(), 10)];
            if (!pre) {
                pre = pt;
                continue;
            }
            else {
                const l = this.lengthCalculation(pre, pt);
                if (run + l > length) {
                    const r = length - run;
                    const deg = Point.findAngle(pre, pt);
                    const x = r * Math.cos(deg * Math.PI / 180);
                    const y = r * Math.sin(deg * Math.PI / 180);
                    found = { x: pre.x + x, y: pre.y + y };
                    break;
                }
                else {
                    run += l;
                }
            }
            pre = pt;
        }
        return found;
    }
    /**
     * @param {PointModel[]}connector- provide the source value.
     * @private
     */
    getPoints(connector) {
        const points = [];
        if (connector.intermediatePoints && (connector.type === 'Straight' || connector.type === 'Orthogonal')) {
            for (let j = 0; j < connector.intermediatePoints.length; j++) {
                points.push(connector.intermediatePoints[parseInt(j.toString(), 10)]);
            }
        }
        return points;
    }
    intersectsRect(rect1, rect2) {
        return ((((rect2.x < (rect1.x + rect1.width)) && (rect1.x < (rect2.x + rect2.width)))
            && (rect2.y < (rect1.y + rect1.height))) && (rect1.y < (rect2.y + rect2.height)));
    }
    /**
     * @param {PointModel[]}points1- provide the source value.
     * @param {PointModel[]}points2- provide the source value.
     * @param {boolean}self- provide the source value.
     * @param {BridgeDirection}bridgeDirection- provide the source value.
     * @param {PointModel[]}zOrder- provide the source value.
     * @private
     */
    intersect(points1, points2, self, bridgeDirection, zOrder) {
        if (self && points2.length >= 2) {
            points2.splice(0, 1);
            points2.splice(0, 1);
        }
        const points = [];
        for (let i = 0; i < points1.length - 1; i++) {
            const pt = this.inter1(points1[parseInt(i.toString(), 10)], points1[i + 1], points2, zOrder, bridgeDirection);
            if (pt.length > 0) {
                for (let k = 0; k < pt.length; k++) {
                    points.push(pt[parseInt(k.toString(), 10)]);
                }
            }
            if (self && points2.length >= 1) {
                points2.splice(0, 1);
            }
        }
        return points;
    }
    /**
     * @param {PointModel}startPt- provide the target  value.
     * @param {PointModel}endPt- provide the target  value.
     * @param {PointModel[]}pts- provide the target  value.
     * @param {boolean}zOrder- provide the target  value.
     * @param {BridgeDirection}bridgeDirection- provide the target  value.
     * @private
     */
    inter1(startPt, endPt, pts, zOrder, bridgeDirection) {
        const points1 = [];
        for (let i = 0; i < pts.length - 1; i++) {
            const point = intersect2(startPt, endPt, pts[parseInt(i.toString(), 10)], pts[i + 1]);
            if (!this.isEmptyPoint(point)) {
                let angle = this.angleCalculation(startPt, endPt);
                let angle1 = this.angleCalculation(pts[parseInt(i.toString(), 10)], pts[i + 1]);
                angle = this.checkForHorizontalLine(angle);
                angle1 = this.checkForHorizontalLine(angle1);
                switch (bridgeDirection) {
                    case 'Left':
                    case 'Right':
                        if (angle > angle1) {
                            points1.push(point);
                        }
                        break;
                    case 'Top':
                    case 'Bottom':
                        if (angle < angle1) {
                            points1.push(point);
                        }
                        break;
                }
                if (angle === angle1 && zOrder) {
                    points1.push(point);
                }
            }
        }
        return points1;
    }
    checkForHorizontalLine(angle) {
        let temp = 0;
        const roundedAngle = Math.abs(angle);
        if (roundedAngle > 90) {
            temp = 180 - roundedAngle;
        }
        else {
            temp = roundedAngle;
        }
        return temp;
    }
    isEmptyPoint(point) {
        return point.x === 0 && point.y === 0;
    }
    getLengthAtFractionPoint(connector, pointAt) {
        let confirm = 100;
        let pointIndex = -1;
        let fullLength = 0;
        let segmentIndex = -1;
        let count = 0;
        let lengthAtFractionPt = 0;
        let pt1 = connector.sourcePoint;
        let previouspt2 = pt1;
        const points = [];
        for (let i = 0; i < connector.intermediatePoints.length; i++) {
            const point2 = connector.intermediatePoints[parseInt(i.toString(), 10)];
            points.push(point2);
        }
        for (let j = 0; j < points.length; j++) {
            const pt2 = points[parseInt(j.toString(), 10)];
            const suspect = this.getSlope(pt2, pt1, pointAt, connector);
            if (suspect < confirm) {
                confirm = suspect;
                lengthAtFractionPt = fullLength + this.lengthCalculation(pointAt, previouspt2);
                segmentIndex = count;
                pointIndex = j;
            }
            fullLength += Point.findLength(pt2, pt1);
            pt1 = pt2;
            previouspt2 = pt2;
        }
        count++;
        const lengthFraction = {
            lengthFractionIndex: lengthAtFractionPt, fullLength: fullLength,
            segmentIndex: segmentIndex, pointIndex: pointIndex
        };
        return lengthFraction;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getSlope(startPt, endPt, point, connector) {
        const three = 3.0;
        const delX = Math.abs(startPt.x - endPt.x);
        const delY = Math.abs(startPt.y - endPt.y);
        const lhs = ((point.y - startPt.y) / (endPt.y - startPt.y));
        const rhs = ((point.x - startPt.x) / (endPt.x - startPt.x));
        if (!isFinite(lhs) || !isFinite(rhs) || isNaN(lhs) || isNaN(rhs)) {
            if (startPt.x === endPt.x) {
                if (startPt.y === endPt.y) {
                    return 10000;
                }
                else if (((startPt.y > point.y) && (point.y > endPt.y)) || ((startPt.y < point.y) && (point.y < endPt.y))) {
                    return Math.abs(startPt.x - point.x);
                }
            }
            else if (startPt.y === endPt.y) {
                if (((startPt.x > point.x) && (point.x > endPt.x)) || ((startPt.x < point.x) && (point.x < endPt.x))) {
                    return Math.abs(startPt.y - point.y);
                }
            }
        }
        else {
            if ((startPt.x >= point.x && point.x >= endPt.x) || (startPt.x <= point.x && point.x <= endPt.x) || delX < three) {
                if ((startPt.y >= point.y && point.y >= endPt.y) || (startPt.y <= point.y && point.y <= endPt.y) || delY < three) {
                    return Math.abs(lhs - rhs);
                }
            }
        }
        return 10000;
    }
    /**
     * @param {PointModel}startPt- provide the target  value.
     * @param {PointModel}endPt- provide the target  value.
     * @private
     */
    angleCalculation(startPt, endPt) {
        const xDiff = startPt.x - endPt.x;
        const yDiff = startPt.y - endPt.y;
        return Math.atan2(yDiff, xDiff) * (180 / Math.PI);
    }
    lengthCalculation(startPt, endPt) {
        //removed a try catch from here
        const len = Math.sqrt(((startPt.x - endPt.x) * (startPt.x - endPt.x)) + ((startPt.y - endPt.y) * (startPt.y - endPt.y)));
        return len;
    }
    /**
     * Constructor for the bridging module
     *
     * @private
     */
    constructor() {
        //constructs the bridging module
    }
    /**
     *To destroy the ruler
     *
     * @returns {void} To destroy the ruler
     */
    destroy() {
        /**
         * Destroys the bridging module
         */
    }
    /**
     * Core method to return the component name.
     *
     * @returns {string}  Core method to return the component name.
     * @private
     */
    getModuleName() {
        /**
         * Returns the module name
         */
        return 'Bridging';
    }
}
